import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskOrganizationsRoute: InvariantJiraRoute = {
	name: 'servicedesk-organizations',
	path: '/jira/servicedesk/projects/:projectKey/organizations',
	exact: true,
};
